import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth/auth-guard.service';
import { CheckRolesGuardService } from './core/services/auth/check-roles-guard.service';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./main/content/authentication/authentication.module').then(module => module.AuthenticationModule)
  },
  {
    path: 'mantenimiento',
    loadChildren: () => import('./main/content/maintenance/maintenance.module').then(module => module.MaintenanceModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant', 'owner', 'both']
    }
  },
  {
    path: 'adelantos',
    loadChildren: () => import('./main/content/advances/advances.module').then(module => module.AdvancesModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['owner', 'both', 'admin']
    }
  },
  {
    path: 'account',
    loadChildren: () => import('./main/content/my-account/my-account.module').then(module => module.MyAccountModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant', 'owner', 'both', 'admin']
    }
  },
  {
    path: 'terminos',
    loadChildren: () => import('./main/content/terminos/terminos.module').then(module => module.TerminosModule)
  },{
    path: 'terminos-de-adelantos',
    loadChildren: () => import('./main/content/terminos-adelantos/terminos-adelantos.module').then(module => module.TerminosAdelantosModule)
  },
  {
    path: 'politicas',
    loadChildren: () => import('./main/content/politicas/politicas.module').then(module => module.PoliticasModule)
  },
  {
    path: 'ayuda',
    loadChildren: () => import('./main/content/help/help.module').then(module => module.HelpModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant', 'owner', 'both']
    }
  },
  {
    path: 'faq',
    loadChildren: () => import('./main/content/faq/faq.module').then(module => module.FaqModule)
  },
  {
    path: 'netta-score',
    loadChildren: () => import('./main/content/netta-score/netta-score.module').then(module => module.NettaScoreModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant']
    }
  },
  {
    path: 'metodos-de-pago',
    loadChildren: () => import('./main/content/payment-methods/payment-methods.module').then(module => module.PaymentMethodsModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant']
    }
  },
  {
    path: 'rentas',
    loadChildren: () => import('./main/content/my-income/my-income.module').then(module => module.MyIncomeModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant']
    }
  },
  {
    path: 'propiedades',
    loadChildren: () => import('./main/content/properties/properties.module').then(module => module.PropertiesModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['tenant', 'owner', 'both', 'invitado']
    }
  },
  {
    path: 'mis-pagos',
    loadChildren: () => import('./main/content/my-paids/my-paids.module').then(module => module.MyPaidsModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['owner', 'both']
    }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./main/content/dashboard/dashboard.module').then(module => module.DashboardModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['admin']
    }
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./main/content/users/users.module').then(module => module.UsersModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['admin']
    }
  },
  {
    path: 'pagos',
    loadChildren: () => import('./main/content/payments/payments.module').then(module => module.PaymentsModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['admin']
    }
  },
  {
    path: 'cupones',
    loadChildren: () => import('./main/content/cupones/cupones.module').then((module) => module.CuponesModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['admin']
    }
  },
  {
    path: 'custom-layout',
    loadChildren: () => import('./main/content/custom-layout/custom-layout.module').then((module) => module.CustomLayoutModule),
    canActivate: [AuthGuardService, CheckRolesGuardService],
    data: {
      roles: ['admin', 'marketing']
    }
  },
  {
    path: '**',
    loadChildren: () => import('./main/content/authentication/authentication.module').then(module => module.AuthenticationModule),
    canActivate: [AuthGuardService, CheckRolesGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
